import { sendPostMessage } from './helpers';
import { IFramePostMessageType } from './helpers';

export const redirect = () => {
  sendPostMessage(IFramePostMessageType.REDIRECT_TO_REVIEW_COLLECTOR_MODAL);
  return true;
};
